<div class="metadata z-1"><div class="t-sm dark-gray">Group message</div><i class="mi onboarding-grid-event-footer-icon">groups_3</i></div>